<template>
  <div class="clientprofile license-detail-shell">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>

      <div class="page-wrapper">
        <div class="content container-fluid license-detail-page">
          <div class="license-detail-heading">
            <div class="license-detail-heading-copy">
              <h3>Detail Lisensi</h3>
              <p>Kelola lisensi, status koneksi, API, dan tindakan pesan WhatsApp.</p>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link to="/index">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item">
                  <router-link to="/license/list">Akun WhatsApp</router-link>
                </li>
                <li class="breadcrumb-item active">Detail Lisensi</li>
              </ul>
            </div>
            <div class="license-detail-heading-actions">
              <button
                type="button"
                class="btn license-detail-btn license-detail-btn-secondary"
                :disabled="loading || metricsLoading"
                @click="refreshAll"
              >
                <i class="fa" :class="loading || metricsLoading ? 'fa-spinner fa-spin' : 'fa-refresh'"></i>
                Muat Ulang
              </button>
              <router-link to="/license/list" class="btn license-detail-btn license-detail-btn-secondary">
                <i class="fa fa-arrow-left"></i>
                Kembali
              </router-link>
            </div>
          </div>

          <div v-if="loading" class="license-detail-panel license-detail-loading" role="status" aria-live="polite">
            <div class="license-detail-skeleton license-detail-skeleton-hero"></div>
            <div class="license-detail-skeleton-grid">
              <div v-for="index in 5" :key="index" class="license-detail-skeleton license-detail-skeleton-card"></div>
            </div>
            <div class="license-detail-skeleton license-detail-skeleton-line"></div>
            <div class="license-detail-skeleton license-detail-skeleton-line is-short"></div>
          </div>

          <div v-else-if="loadError" class="license-detail-panel license-detail-state" role="alert">
            <span class="license-detail-state-icon is-danger"><i class="fa fa-exclamation-triangle"></i></span>
            <h4>Detail lisensi belum dapat dimuat</h4>
            <p>{{ loadError }}</p>
            <div class="license-detail-state-actions">
              <button type="button" class="btn license-detail-btn license-detail-btn-primary" @click="loadLicense">
                <i class="fa fa-refresh"></i> Coba Lagi
              </button>
              <router-link to="/license/list" class="btn license-detail-btn license-detail-btn-secondary">
                Kembali ke Daftar
              </router-link>
            </div>
          </div>

          <template v-else-if="licenseInfo.id">
            <section class="license-detail-hero">
              <div class="license-detail-hero-main">
                <span class="license-detail-hero-icon" aria-hidden="true">
                  <i class="fa fa-whatsapp"></i>
                </span>
                <div class="license-detail-hero-copy">
                  <div class="license-detail-hero-title">
                    <h1>{{ licenseInfo.license_name || "Lisensi WhatsApp" }}</h1>
                    <button
                      type="button"
                      class="license-detail-edit-title"
                      title="Edit lisensi"
                      aria-label="Edit lisensi"
                      @click="openLicenseEdit"
                    >
                      <i class="fa fa-pencil"></i>
                      <span>Edit Lisensi</span>
                    </button>
                    <span class="license-detail-badge" :class="statusClass">
                      <i class="fa fa-circle"></i>
                      {{ statusLabel }}
                    </span>
                  </div>
                  <div class="license-detail-hero-meta">
                    <button
                      type="button"
                      class="license-detail-phone-copy"
                      :title="'Salin nomor ' + (licenseInfo.license_phone_number || '')"
                      @click="copyPhone"
                    >
                      <i class="fa fa-whatsapp"></i>
                      <span>{{ licenseInfo.license_phone_number || "Nomor belum diatur" }}</span>
                      <i class="fa fa-files-o"></i>
                    </button>
                    <span v-if="licenseInfo.license_email" class="license-detail-meta-item">
                      <i class="fa fa-envelope-o"></i>
                      {{ licenseInfo.license_email }}
                    </span>
                    <span class="license-detail-meta-item">
                      <i class="fa fa-calendar"></i>
                      Dibuat {{ createdDate }}
                    </span>
                  </div>
                  <div class="license-detail-hero-actions">
                    <button
                      type="button"
                      class="btn license-detail-btn license-detail-btn-primary"
                      :disabled="!licenseInfo.id"
                      @click="openScanQr"
                    >
                      <i class="fa fa-qrcode"></i>
                      Scan QR Code
                    </button>
                    <router-link
                      :to="'/omni/connect-to-agent-owner?license_id=' + licenseInfo.id"
                      class="btn license-detail-btn license-detail-btn-secondary"
                    >
                      <i class="fa fa-comments-o"></i>
                      Chat
                    </router-link>
                    <router-link
                      :to="'/subscriptions?license_id=' + licenseInfo.id"
                      class="btn license-detail-btn license-detail-btn-secondary"
                    >
                      <i class="fa fa-shopping-cart"></i>
                      Perpanjang
                    </router-link>
                    <div class="dropdown license-detail-more">
                      <button
                        type="button"
                        class="btn license-detail-btn license-detail-btn-secondary dropdown-toggle"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="fa fa-ellipsis-h"></i>
                        Lainnya
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <router-link
                          :to="'/license/list?license_phone_number=' + (licenseInfo.license_phone_number || '')"
                          class="dropdown-item"
                        >
                          <i class="fa fa-cogs text-info"></i>
                          Kelola Lisensi
                        </router-link>
                        <button type="button" class="dropdown-item" @click="generateLicenseKey">
                          <i class="fa fa-key text-warning"></i>
                          Generate API Key
                        </button>
                        <a :href="docAPI" target="_blank" rel="noopener noreferrer" class="dropdown-item">
                          <i class="fa fa-book text-primary"></i>
                          Dokumentasi API
                        </a>
                        <div class="dropdown-divider"></div>
                        <router-link to="/license/list" class="dropdown-item">
                          <i class="fa fa-list"></i>
                          Daftar Lisensi
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="license-detail-hero-side">
                <div class="license-detail-side-item">
                  <span>Masa Aktif</span>
                  <strong>
                    <span class="license-detail-pill is-blue">{{ masaAktifLabel }}</span>
                  </strong>
                </div>
                <div class="license-detail-side-item">
                  <span>Dibuat</span>
                  <strong>{{ createdDate }}</strong>
                </div>
                <div class="license-detail-side-item license-detail-side-status">
                  <span>Status Koneksi</span>
                  <ul class="license-detail-status-list">
                    <WhatsappSection
                      ref="whatsapp_section"
                      :key="licenseInfo.id"
                      :licenseInfo="licenseInfo"
                      @status-change="onConnectionStatusChange"
                    />
                  </ul>
                </div>
              </div>
            </section>

            <section class="license-detail-stats" aria-label="Ringkasan statistik lisensi">
              <div
                v-for="card in statCards"
                :key="card.key"
                class="license-detail-stat-card"
                :class="card.tone"
              >
                <span class="license-detail-stat-icon">
                  <i :class="card.icon"></i>
                </span>
                <div class="license-detail-stat-copy">
                  <span>
                    {{ card.label }}
                    <em v-if="card.badge" class="license-detail-stat-rate" :class="card.tone">
                      {{ card.badge }}
                    </em>
                  </span>
                  <strong>
                    <i v-if="metricsLoading" class="fa fa-spinner fa-spin"></i>
                    <template v-else>{{ metricValue(card.key) }}</template>
                  </strong>
                  <small>{{ card.hint }}</small>
                </div>
              </div>
            </section>

            <p class="license-detail-muted license-detail-stats-note">
              Statistik mengikuti data akumulasi lisensi dari API. Filter harian dan tren
              perubahan belum tersedia pada kontrak API saat ini.
            </p>

            <div v-if="metricsError" class="license-detail-inline-alert" role="alert">
              <span>
                <i class="fa fa-exclamation-circle"></i>
                {{ metricsError }}
              </span>
              <button type="button" class="license-detail-link-btn" :disabled="metricsLoading" @click="retryMetrics">
                Coba Lagi
              </button>
            </div>

            <div class="license-detail-tabs-head">
              <div class="license-detail-tabs" role="tablist" aria-label="Navigasi detail lisensi">
                <button
                  v-for="tab in tabs"
                  :key="tab.key"
                  type="button"
                  class="license-detail-tab"
                  :class="{ active: activeTab === tab.key }"
                  role="tab"
                  :aria-selected="activeTab === tab.key ? 'true' : 'false'"
                  @click="activeTab = tab.key"
                >
                  <i :class="tab.icon"></i>
                  {{ tab.label }}
                </button>
              </div>
            </div>

            <div v-show="activeTab === 'ringkasan'" class="license-detail-tab-panel" role="tabpanel">
              <div class="license-detail-grid">
                <div class="license-detail-main-column">
                  <section class="license-detail-panel">
                    <div class="license-detail-panel-head">
                      <div>
                        <h4>Informasi Lisensi</h4>
                        <p>Detail data yang terdaftar pada lisensi ini.</p>
                      </div>
                    </div>
                    <dl class="license-detail-info-list">
                      <div>
                        <dt><i class="fa fa-whatsapp"></i> Nomor WhatsApp</dt>
                        <dd>{{ licenseInfo.license_phone_number || "-" }}</dd>
                      </div>
                      <div>
                        <dt><i class="fa fa-tag"></i> Nama / Label</dt>
                        <dd>{{ licenseInfo.license_name || "-" }}</dd>
                      </div>
                      <div>
                        <dt><i class="fa fa-envelope-o"></i> Email</dt>
                        <dd>{{ licenseInfo.license_email || "-" }}</dd>
                      </div>
                      <div>
                        <dt><i class="fa fa-signal"></i> Status Lisensi</dt>
                        <dd>
                          <span class="license-detail-badge" :class="statusClass">
                            <i class="fa fa-circle"></i>
                            {{ statusLabel }}
                          </span>
                        </dd>
                      </div>
                      <div>
                        <dt><i class="fa fa-calendar-check-o"></i> Masa Aktif</dt>
                        <dd>{{ masaAktifLabel }}</dd>
                      </div>
                      <div>
                        <dt><i class="fa fa-calendar"></i> Dibuat</dt>
                        <dd>{{ createdDate }}</dd>
                      </div>
                    </dl>
                  </section>

                  <section class="license-detail-panel license-detail-info-box">
                    <span class="license-detail-info-box-icon"><i class="fa fa-shield"></i></span>
                    <div>
                      <strong>Keamanan &amp; Privasi</strong>
                      <p>
                        Semua koneksi WhatsApp menggunakan sistem resmi dan aman. Scan QR dilakukan
                        langsung pada perangkat Anda dan Waajo tidak menyimpan password WhatsApp.
                      </p>
                    </div>
                  </section>
                </div>

                <aside class="license-detail-side-column">
                  <section class="license-detail-panel license-detail-quick">
                    <div class="license-detail-panel-head">
                      <div>
                        <h4>Akses Cepat</h4>
                        <p>Pintasan yang sering digunakan.</p>
                      </div>
                    </div>

                    <button type="button" class="license-detail-quick-card" @click="activeTab = 'api'">
                      <span class="license-detail-quick-icon is-key"><i class="fa fa-key"></i></span>
                      <span class="license-detail-quick-copy">
                        <strong>API Key</strong>
                        <small>{{ apiKeyMasked }}</small>
                      </span>
                      <i class="fa fa-angle-right"></i>
                    </button>

                    <a
                      :href="docAPI"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="license-detail-quick-card"
                    >
                      <span class="license-detail-quick-icon is-doc"><i class="fa fa-book"></i></span>
                      <span class="license-detail-quick-copy">
                        <strong>Dokumentasi API</strong>
                        <small>Panduan integrasi dan endpoint</small>
                      </span>
                      <i class="fa fa-external-link"></i>
                    </a>

                    <button type="button" class="license-detail-quick-card" @click="openScanQr">
                      <span class="license-detail-quick-icon is-qr"><i class="fa fa-qrcode"></i></span>
                      <span class="license-detail-quick-copy">
                        <strong>Scan QR Code</strong>
                        <small>Hubungkan ulang perangkat WhatsApp</small>
                      </span>
                      <i class="fa fa-angle-right"></i>
                    </button>
                  </section>

                  <section class="license-detail-panel license-detail-help">
                    <span class="license-detail-help-icon"><i class="fa fa-question"></i></span>
                    <h4>Butuh bantuan?</h4>
                    <p>Lihat panduan penggunaan atau hubungi tim support jika mengalami kendala.</p>
                    <a
                      :href="supportLink"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="btn license-detail-btn license-detail-btn-secondary btn-block"
                    >
                      Buka Pusat Bantuan
                      <i class="fa fa-external-link"></i>
                    </a>
                  </section>
                </aside>
              </div>
            </div>

            <div v-show="activeTab === 'api'" class="license-detail-tab-panel" role="tabpanel">
              <div class="license-detail-grid is-single">
                <section class="license-detail-panel">
                  <div class="license-detail-panel-head">
                    <div>
                      <h4>API Key</h4>
                      <p>
                        Gunakan key ini untuk integrasi. Key ditampilkan tersamarkan secara default.
                      </p>
                    </div>
                  </div>

                  <div class="license-detail-key-row">
                    <code class="license-detail-key">{{ apiKeyDisplay }}</code>
                    <div class="license-detail-key-actions">
                      <button
                        type="button"
                        class="btn license-detail-btn license-detail-btn-secondary"
                        :disabled="!licenseKey"
                        @click="toggleApiKey"
                      >
                        <i class="fa" :class="apiKeyVisible ? 'fa-eye-slash' : 'fa-eye'"></i>
                        {{ apiKeyVisible ? "Sembunyikan" : "Tampilkan" }}
                      </button>
                      <button
                        type="button"
                        class="btn license-detail-btn license-detail-btn-secondary"
                        :disabled="!licenseKey"
                        @click="copyApiKey"
                      >
                        <i class="fa fa-files-o"></i>
                        Salin
                      </button>
                      <button
                        type="button"
                        class="btn license-detail-btn license-detail-btn-primary"
                        :disabled="keySubmitting"
                        @click="generateLicenseKey"
                      >
                        <i class="fa" :class="keySubmitting ? 'fa-spinner fa-spin' : 'fa-refresh'"></i>
                        Generate Ulang
                      </button>
                    </div>
                  </div>

                  <p v-if="!licenseKey" class="license-detail-muted">
                    API key belum tersedia untuk lisensi ini.
                  </p>
                  <p v-else class="license-detail-muted">
                    Menampilkan atau menyalin key tidak mengubah koneksi API yang sedang berjalan.
                    Generate ulang key akan memutus koneksi API lama.
                  </p>

                  <div v-if="apiKeyError" class="license-detail-inline-alert" role="alert">
                    <span><i class="fa fa-exclamation-circle"></i> {{ apiKeyError }}</span>
                  </div>
                </section>

                <section class="license-detail-panel license-detail-doc-card">
                  <span class="license-detail-quick-icon is-doc"><i class="fa fa-book"></i></span>
                  <div>
                    <h4>Dokumentasi API</h4>
                    <p>
                      Pelajari cara menghubungkan aplikasi lain dengan lisensi WhatsApp ini melalui
                      dokumentasi API Waajo.
                    </p>
                    <a
                      :href="docAPI"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="btn license-detail-btn license-detail-btn-primary"
                    >
                      Buka Dokumentasi
                      <i class="fa fa-external-link"></i>
                    </a>
                  </div>
                </section>
              </div>
            </div>

            <div v-show="activeTab === 'aktivitas'" class="license-detail-tab-panel" role="tabpanel">
              <section class="license-detail-panel">
                <div class="license-detail-panel-head">
                  <div>
                    <h4>Aktivitas</h4>
                    <p>
                      Riwayat pesan dan broadcast tetap tersedia melalui halaman laporan yang sudah ada.
                    </p>
                  </div>
                </div>
                <div class="license-detail-activity-grid">
                  <router-link to="/message_report/inbox" class="license-detail-activity-card">
                    <span class="license-detail-stat-icon is-blue"><i class="fa fa-download"></i></span>
                    <div>
                      <strong>Pesan Masuk</strong>
                      <small>Lihat riwayat pesan yang diterima.</small>
                    </div>
                    <i class="fa fa-angle-right"></i>
                  </router-link>
                  <router-link to="/message_report/outbox" class="license-detail-activity-card">
                    <span class="license-detail-stat-icon is-green"><i class="fa fa-upload"></i></span>
                    <div>
                      <strong>Pesan Keluar</strong>
                      <small>Lihat riwayat pesan yang dikirim.</small>
                    </div>
                    <i class="fa fa-angle-right"></i>
                  </router-link>
                  <router-link to="/broadcast-v2" class="license-detail-activity-card">
                    <span class="license-detail-stat-icon is-amber"><i class="fa fa-bullhorn"></i></span>
                    <div>
                      <strong>Broadcast</strong>
                      <small>Kelola dan lihat riwayat broadcast.</small>
                    </div>
                    <i class="fa fa-angle-right"></i>
                  </router-link>
                  <router-link to="/auto-follow-up" class="license-detail-activity-card">
                    <span class="license-detail-stat-icon is-purple"><i class="fa fa-refresh"></i></span>
                    <div>
                      <strong>Auto Follow Up</strong>
                      <small>Pantau alur follow up berjalan.</small>
                    </div>
                    <i class="fa fa-angle-right"></i>
                  </router-link>
                </div>
                <p class="license-detail-muted mt-3 mb-0">
                  Halaman laporan membuka data seluruh lisensi. Gunakan filter lisensi pada halaman
                  laporan untuk melihat data lisensi ini saja.
                </p>
              </section>
            </div>

            <div v-show="activeTab === 'pengaturan'" class="license-detail-tab-panel" role="tabpanel">
              <div class="license-detail-grid is-single">
                <section class="license-detail-panel">
                  <div class="license-detail-panel-head">
                    <div>
                      <h4>Koneksi WhatsApp</h4>
                      <p>Periksa status dan hubungkan ulang perangkat WhatsApp.</p>
                    </div>
                  </div>
                  <p class="license-detail-muted mt-0 mb-3">
                    Status koneksi terbaru ditampilkan pada bagian header lisensi di atas.
                    Gunakan tombol berikut untuk memeriksa ulang atau menghubungkan perangkat.
                  </p>
                  <div class="license-detail-settings-actions">
                    <button type="button" class="btn license-detail-btn license-detail-btn-primary" @click="openScanQr">
                      <i class="fa fa-qrcode"></i>
                      Scan QR Code
                    </button>
                    <button type="button" class="btn license-detail-btn license-detail-btn-secondary" @click="refreshConnectionStatus">
                      <i class="fa fa-refresh"></i>
                      Cek Status
                    </button>
                    <button
                      v-if="licenseInfo.license_phone_number"
                      type="button"
                      class="btn license-detail-btn license-detail-btn-danger"
                      @click="logoutWhatsapp"
                    >
                      <i class="fa fa-sign-out"></i>
                      Logout
                    </button>
                  </div>
                  <p class="license-detail-muted">
                    Logout akan memutus sesi WhatsApp pada lisensi ini. Anda perlu scan QR kembali
                    untuk menghubungkannya.
                  </p>
                </section>
              </div>
            </div>

            <section id="tindakan-berisiko" class="license-detail-danger" aria-label="Tindakan berisiko">
              <div class="license-detail-danger-head">
                <span class="license-detail-danger-icon"><i class="fa fa-exclamation"></i></span>
                <div>
                  <h4>Tindakan Berisiko</h4>
                  <p>
                    Tindakan ini menghapus data secara permanen. Riwayat chat, auto responder,
                    riwayat broadcast, dan data pesan terkait akan ikut terdampak. Pastikan Anda
                    sudah memahami konsekuensinya.
                  </p>
                </div>
              </div>

              <div v-if="emptyError" class="license-detail-inline-alert is-danger" role="alert">
                <span><i class="fa fa-exclamation-circle"></i> {{ emptyError }}</span>
              </div>

              <div class="license-detail-danger-actions">
                <div class="license-detail-danger-card">
                  <div>
                    <strong>Empty Inbox</strong>
                    <p>Hapus semua pesan masuk pada lisensi ini.</p>
                  </div>
                  <button
                    type="button"
                    class="btn license-detail-btn license-detail-btn-danger"
                    :disabled="!!emptyLoading"
                    @click="confirmEmpty('inbox')"
                  >
                    <i class="fa" :class="emptyLoading === 'inbox' ? 'fa-spinner fa-spin' : 'fa-trash'"></i>
                    {{ emptyLoading === 'inbox' ? "Menghapus..." : "Hapus Pesan Masuk" }}
                  </button>
                </div>
                <div class="license-detail-danger-card">
                  <div>
                    <strong>Empty Outbox</strong>
                    <p>Hapus semua pesan keluar pada lisensi ini.</p>
                  </div>
                  <button
                    type="button"
                    class="btn license-detail-btn license-detail-btn-danger"
                    :disabled="!!emptyLoading"
                    @click="confirmEmpty('outbox')"
                  >
                    <i class="fa" :class="emptyLoading === 'outbox' ? 'fa-spinner fa-spin' : 'fa-trash'"></i>
                    {{ emptyLoading === 'outbox' ? "Menghapus..." : "Hapus Pesan Keluar" }}
                  </button>
                </div>
              </div>
            </section>

            <div
              id="editLicenseDetail"
              class="modal custom-modal fade license-detail-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="editLicenseDetailTitle"
              data-backdrop="static"
            >
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 id="editLicenseDetailTitle" class="modal-title">
                      <i class="fa fa-pencil"></i>
                      Edit Lisensi
                    </h5>
                    <button
                      type="button"
                      class="close"
                      aria-label="Tutup"
                      :disabled="editSaving"
                      @click="closeLicenseEdit"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <p class="license-detail-form-note">
                      Perbarui profil lisensi. Nomor WhatsApp hanya dapat diubah saat lisensi
                      tidak terhubung. Status koneksi, masa aktif, dan API Key tidak dapat
                      diubah dari halaman ini.
                    </p>

                    <div v-if="editErrors.api" class="alert alert-danger" role="alert">
                      <i class="fa fa-exclamation-circle"></i>
                      {{ editErrors.api }}
                    </div>

                    <form novalidate @submit.prevent="saveLicenseEdit">
                      <div class="form-group">
                        <label for="editLicenseName">Nama Lisensi <span class="text-danger">*</span></label>
                        <input
                          id="editLicenseName"
                          v-model="editForm.license_name"
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': !!editErrors.name }"
                          maxlength="100"
                          autocomplete="off"
                          :disabled="editSaving"
                          @input="editErrors.name = ''; editErrors.api = ''"
                        />
                        <div v-if="editErrors.name" class="invalid-feedback">
                          {{ editErrors.name }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="editLicenseEmail">Email <span class="text-danger">*</span></label>
                        <input
                          id="editLicenseEmail"
                          v-model="editForm.license_email"
                          type="email"
                          class="form-control"
                          :class="{ 'is-invalid': !!editErrors.email }"
                          maxlength="150"
                          autocomplete="off"
                          :disabled="editSaving"
                          @input="editErrors.email = ''; editErrors.api = ''"
                        />
                        <div v-if="editErrors.email" class="invalid-feedback">
                          {{ editErrors.email }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="editLicensePhone">Nomor WhatsApp</label>
                        <div class="license-detail-edit-status">
                          <span class="license-detail-badge" :class="connectionBadgeClass">
                            <i class="fa fa-circle"></i>
                            {{ connectionStatusLabel }}
                          </span>
                          <button
                            v-if="canDisconnectWhatsapp"
                            type="button"
                            class="btn license-detail-btn license-detail-btn-danger license-detail-btn-sm"
                            :disabled="disconnectLoading || editSaving"
                            @click="disconnectWhatsappForEdit"
                          >
                            <i
                              class="fa"
                              :class="disconnectLoading ? 'fa-spinner fa-spin' : 'fa-plug'"
                            ></i>
                            {{ disconnectLoading ? "Menunggu Offline..." : "Logout WhatsApp" }}
                          </button>
                          <button
                            v-else-if="connectionStatus === null && isCurrentPhoneValid"
                            type="button"
                            class="btn license-detail-btn license-detail-btn-secondary license-detail-btn-sm"
                            :disabled="connectionLoading || editSaving"
                            @click="fetchConnectionStatus()"
                          >
                            <i
                              class="fa"
                              :class="connectionLoading ? 'fa-spinner fa-spin' : 'fa-refresh'"
                            ></i>
                            Cek Status
                          </button>
                        </div>

                        <input
                          id="editLicensePhone"
                          v-model="editForm.license_phone_number"
                          type="tel"
                          class="form-control"
                          :class="{
                            'is-invalid': !!editErrors.phone,
                            'license-detail-readonly': phoneFieldDisabled
                          }"
                          maxlength="20"
                          placeholder="Contoh: 6281234567890"
                          autocomplete="off"
                          :disabled="phoneFieldDisabled"
                          @input="editErrors.phone = ''; editErrors.api = ''; connectionError = ''"
                        />
                        <div v-if="editErrors.phone" class="invalid-feedback">
                          {{ editErrors.phone }}
                        </div>
                        <small
                          class="form-text"
                          :class="connectionStatus === 1 ? 'text-danger' : 'text-muted'"
                        >
                          {{ phoneHelpMessage }}
                        </small>
                        <div
                          v-if="connectionError"
                          class="license-detail-inline-alert is-danger mt-2 mb-0"
                          role="alert"
                        >
                          <span><i class="fa fa-exclamation-circle"></i> {{ connectionError }}</span>
                        </div>
                      </div>

                      <div class="license-detail-modal-actions">
                        <button
                          type="button"
                          class="btn license-detail-btn license-detail-btn-secondary"
                          :disabled="editSaving"
                          @click="closeLicenseEdit"
                        >
                          Batal
                        </button>
                        <button
                          type="submit"
                          class="btn license-detail-btn license-detail-btn-primary"
                          :disabled="editSaving || disconnectLoading || connectionLoading"
                        >
                          <i class="fa" :class="editSaving ? 'fa-spinner fa-spin' : 'fa-save'"></i>
                          {{ editSaving ? "Menyimpan..." : "Simpan Perubahan" }}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/utils/helper";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import WhatsappSection from "./whatsappSection.vue";

const EMPTY_LICENSE = {
  id: "",
  license_name: "",
  license_phone_number: "",
  license_email: "",
  license_key: "",
  license_masa_aktif: "",
  is_unlimited: "",
  status_label: "",
  create_datetime: "",
  license_create_datetime: ""
};

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    WhatsappSection
  },
  data() {
    return {
      loading: true,
      loadError: "",
      activeTab: "ringkasan",
      docAPI: process.env.VUE_APP_API_DOC,
      licenseInfo: Object.assign({}, EMPTY_LICENSE),
      agentTotal: null,
      messageTotal: null,
      messageSuccess: null,
      messagePending: null,
      messageError: null,
      metricsLoading: false,
      metricsError: "",
      apiKeyVisible: false,
      keySubmitting: false,
      apiKeyError: "",
      emptyLoading: "",
      emptyError: "",
      editForm: {
        id: "",
        license_name: "",
        license_email: "",
        license_phone_number: ""
      },
      editErrors: {
        name: "",
        email: "",
        phone: "",
        api: ""
      },
      editSaving: false,
      editModalOpen: false,
      connectionStatus: null,
      connectionStatusMessage: "",
      connectionLoading: false,
      disconnectLoading: false,
      connectionError: "",
      requestId: 0
    };
  },
  computed: {
    tabs() {
      return [
        { key: "ringkasan", label: "Ringkasan", icon: "fa fa-dashboard" },
        { key: "api", label: "API & Integrasi", icon: "fa fa-key" },
        { key: "aktivitas", label: "Aktivitas", icon: "fa fa-history" },
        { key: "pengaturan", label: "Pengaturan", icon: "fa fa-cog" }
      ];
    },
    licenseKey() {
      return this.licenseInfo.license_key || "";
    },
    apiKeyMasked() {
      if (!this.licenseKey) {
        return "API key belum tersedia";
      }
      return "••••••••" + this.licenseKey.slice(-4);
    },
    apiKeyDisplay() {
      if (!this.licenseKey) {
        return "API key belum tersedia";
      }
      return this.apiKeyVisible ? this.licenseKey : this.apiKeyMasked;
    },
    masaAktifLabel() {
      if (Number(this.licenseInfo.is_unlimited) === 1) {
        return "Unlimited";
      }
      return this.licenseInfo.license_masa_aktif || "-";
    },
    statusLabel() {
      return this.licenseInfo.status_label || (Number(this.licenseInfo.is_unlimited) === 1 ? "Active" : "-");
    },
    statusClass() {
      const label = String(this.statusLabel).toLowerCase();
      if (label.indexOf("active") !== -1 || Number(this.licenseInfo.is_unlimited) === 1) {
        return "is-active";
      }
      if (label.indexOf("expired") !== -1) {
        return "is-expired";
      }
      return "is-neutral";
    },
    createdDate() {
      return this.formatCreatedDate(
        this.licenseInfo.create_datetime || this.licenseInfo.license_create_datetime
      );
    },
    statCards() {
      const total = Number(this.messageTotal);
      const success = Number(this.messageSuccess);
      const error = Number(this.messageError);
      const hasSuccess = this.messageSuccess !== null && typeof this.messageSuccess !== "undefined";
      const hasError = this.messageError !== null && typeof this.messageError !== "undefined";
      const successRate =
        isFinite(total) && total > 0 && hasSuccess && isFinite(success)
          ? Math.round((success / total) * 100) + "%"
          : "";
      const errorRate =
        isFinite(total) && total > 0 && hasError && isFinite(error)
          ? Math.round((error / total) * 100) + "%"
          : "";
      return [
        {
          key: "messageTotal",
          label: "Total Pesan",
          hint: "Akumulasi lisensi",
          icon: "fa fa-envelope-o",
          tone: "is-blue",
          badge: ""
        },
        {
          key: "messageSuccess",
          label: "Terkirim",
          hint: "Persentase dari total",
          icon: "fa fa-check-circle-o",
          tone: "is-green",
          badge: successRate
        },
        {
          key: "messagePending",
          label: "Pending",
          hint: "Menunggu proses",
          icon: "fa fa-clock-o",
          tone: "is-amber",
          badge: ""
        },
        {
          key: "messageError",
          label: "Gagal",
          hint: "Persentase dari total",
          icon: "fa fa-exclamation-triangle",
          tone: "is-red",
          badge: errorRate
        },
        {
          key: "agentTotal",
          label: "Agents",
          hint: "Terhubung lisensi",
          icon: "fa fa-users",
          tone: "is-purple",
          badge: ""
        }
      ];
    },
    supportLink() {
      const contact = process.env.VUE_APP_CONTACT_WAAJO || "";
      if (contact) {
        return "https://wa.me/" + String(contact).replace(/[^0-9]/g, "");
      }
      return "https://waajo.gitbook.io/waajo-docs/";
    },
    isCurrentPhoneValid() {
      return this.isValidPhone(this.licenseInfo.license_phone_number);
    },
    canEditPhone() {
      if (this.connectionLoading || this.disconnectLoading) {
        return false;
      }
      if (!this.isCurrentPhoneValid) {
        return true;
      }
      return this.connectionStatus === 0;
    },
    phoneFieldDisabled() {
      return (
        this.editSaving ||
        this.connectionLoading ||
        this.disconnectLoading ||
        !this.canEditPhone
      );
    },
    phoneHelpMessage() {
      if (this.connectionLoading) {
        return "Memeriksa status koneksi WhatsApp...";
      }
      if (!this.isCurrentPhoneValid) {
        return "Nomor WhatsApp belum valid. Masukkan nomor yang benar untuk memperbaiki lisensi.";
      }
      if (this.connectionStatus === 1) {
        return "Nomor WhatsApp tidak dapat diubah saat masih terhubung. Putuskan koneksi WhatsApp terlebih dahulu untuk mengganti nomor.";
      }
      if (this.connectionStatus === 0) {
        return "Nomor WhatsApp dapat diubah karena lisensi sedang tidak terhubung.";
      }
      return "Status koneksi belum dapat dipastikan. Nomor terkunci sampai status Offline terkonfirmasi.";
    },
    connectionStatusLabel() {
      if (!this.isCurrentPhoneValid) {
        return "Belum diatur";
      }
      if (this.connectionStatus === 1) {
        return "Online";
      }
      if (this.connectionStatus === 0) {
        return "Offline";
      }
      return "Belum diketahui";
    },
    connectionBadgeClass() {
      if (!this.isCurrentPhoneValid) {
        return "is-neutral";
      }
      if (this.connectionStatus === 1) {
        return "is-active";
      }
      if (this.connectionStatus === 0) {
        return "is-expired";
      }
      return "is-neutral";
    },
    canDisconnectWhatsapp() {
      return (
        this.connectionStatus === 1 &&
        this.isCurrentPhoneValid &&
        !this.editSaving &&
        !this.connectionLoading
      );
    }
  },
  created() {
    this.loadLicense();
  },
  watch: {
    "$route.query.id"() {
      this.loadLicense();
    }
  },
  methods: {
    metricValue(key) {
      const value = this[key];
      if (value === null || typeof value === "undefined") {
        return "—";
      }
      const numeric = Number(value);
      if (!isFinite(numeric)) {
        return "—";
      }
      return numeric.toLocaleString("id-ID");
    },
    formatCreatedDate(value) {
      if (value === null || typeof value === "undefined" || value === "") {
        return "-";
      }
      const raw = String(value);
      if (/^0{4}-0{2}-0{2}/.test(raw)) {
        return "-";
      }
      if (/^\d+$/.test(raw)) {
        const numeric = Number(raw);
        if (numeric <= 0) {
          return "-";
        }
        const unix = numeric > 9999999999 ? Math.floor(numeric / 1000) : numeric;
        return formatDate(new Date(unix * 1000), "month_name");
      }
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        return raw;
      }
      return formatDate(date, "month_name");
    },
    getErrorMessage(error, fallback) {
      let message = "";
      if (error && error.response && error.response.data) {
        message = error.response.data.msg || error.response.data.message || "";
      }
      if (!message && error && error.message) {
        message = error.message;
      }
      message = String(message)
        .replace(/<br\s*\/?>/gi, " ")
        .replace(/<[^>]*>/g, "")
        .trim();
      if (!message) {
        return fallback;
      }
      if (
        /sql|select |table|column|backend|redis|worker|stack|trace|invalid|failed|error/i.test(
          message
        )
      ) {
        return fallback;
      }
      return message;
    },
    resetLicenseData() {
      this.licenseInfo = Object.assign({}, EMPTY_LICENSE);
      this.agentTotal = null;
      this.messageTotal = null;
      this.messageSuccess = null;
      this.messagePending = null;
      this.messageError = null;
      this.metricsLoading = false;
      this.metricsError = "";
      this.apiKeyVisible = false;
      this.apiKeyError = "";
      this.emptyError = "";
      this.emptyLoading = "";
      this.resetLicenseEdit();
    },
    async loadLicense() {
      const requestId = ++this.requestId;
      const id = this.$route.query.id;
      this.resetLicenseData();
      this.loadError = "";
      this.loading = true;

      if (!id) {
        this.loading = false;
        this.loadError = "ID lisensi tidak ditemukan pada tautan.";
        return;
      }

      try {
        const response = await this.$store.dispatch("license/getLicenseById", id);
        if (requestId !== this.requestId) {
          return;
        }
        const data = (response && response.data) || {};
        const license = Object.assign({}, EMPTY_LICENSE, data);
        if (Number(license.is_unlimited) === 1) {
          license.status_label = "Active";
        }
        this.licenseInfo = license;
        this.loading = false;
        this.loadMetrics(id, requestId);

        if (String(this.$route.query.show_qr_code) === "1") {
          this.$nextTick(() => {
            setTimeout(() => {
              if (requestId === this.requestId) {
                this.openScanQr(false);
              }
            }, 100);
          });
        } else if (String(this.$route.query.edit) === "1") {
          this.$nextTick(() => {
            setTimeout(() => {
              if (requestId === this.requestId) {
                this.openLicenseEdit();
              }
            }, 150);
          });
        }
      } catch (error) {
        if (requestId !== this.requestId) {
          return;
        }
        this.loading = false;
        this.loadError = this.getErrorMessage(
          error,
          "Detail lisensi belum dapat dimuat. Periksa koneksi Anda dan coba lagi."
        );
      }
    },
    async loadMetrics(id, requestId) {
      if (!id) {
        return;
      }
      const currentRequest = requestId || this.requestId;
      const params = { license_id: id, provider: "whatsapp" };
      this.metricsLoading = true;
      this.metricsError = "";
      this.agentTotal = null;
      this.messageTotal = null;
      this.messageSuccess = null;
      this.messagePending = null;
      this.messageError = null;

      const task = (name, key) =>
        this.$store
          .dispatch(name, params)
          .then(value => ({ key: key, value: value }))
          .catch(error => ({ key: key, error: error }));

      const results = await Promise.all([
        task("license/getAgentTotal", "agentTotal"),
        task("license/getMessageTotal", "messageTotal"),
        task("license/getMessageSuccess", "messageSuccess"),
        task("license/getMessagePending", "messagePending"),
        task("license/getMessageError", "messageError")
      ]);

      if (currentRequest !== this.requestId) {
        return;
      }

      let failed = false;
      results.forEach(result => {
        if (result.error) {
          failed = true;
          return;
        }
        this[result.key] = result.value;
      });
      this.metricsLoading = false;
      this.metricsError = failed ? "Sebagian statistik lisensi belum dapat dimuat." : "";
    },
    retryMetrics() {
      if (this.licenseInfo.id) {
        this.loadMetrics(this.licenseInfo.id);
      }
    },
    refreshAll() {
      this.loadLicense();
    },
    openScanQr(withConfirmation) {
      if (!this.$refs.whatsapp_section || !this.licenseInfo.id) {
        return;
      }
      if (withConfirmation === false) {
        this.$refs.whatsapp_section.loginWithoutPopup(this.licenseInfo.id);
        return;
      }
      this.$refs.whatsapp_section.login(this.licenseInfo.id);
    },
    refreshConnectionStatus() {
      if (this.$refs.whatsapp_section && this.licenseInfo.license_phone_number) {
        this.$refs.whatsapp_section.isOnline(this.licenseInfo.license_phone_number);
      }
    },
    logoutWhatsapp() {
      if (this.$refs.whatsapp_section && this.licenseInfo.license_phone_number) {
        this.$refs.whatsapp_section.logout(this.licenseInfo.license_phone_number);
      }
    },
    async copyPhone() {
      if (!this.licenseInfo.license_phone_number) {
        return;
      }
      const copied = await this.copyText(this.licenseInfo.license_phone_number);
      this.notifyCopy(copied, "Nomor WhatsApp");
    },
    async copyApiKey() {
      if (!this.licenseKey) {
        return;
      }
      const copied = await this.copyText(this.licenseKey);
      this.notifyCopy(copied, "API key");
    },
    notifyCopy(copied, label) {
      this.$fire({
        title: copied ? "Berhasil" : "Gagal",
        text: copied
          ? label + " berhasil disalin."
          : label + " belum dapat disalin. Salin secara manual.",
        type: copied ? "success" : "error",
        timer: 2500
      });
    },
    copyText(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard
          .writeText(text)
          .then(() => true)
          .catch(() => this.fallbackCopyText(text));
      }
      return Promise.resolve(this.fallbackCopyText(text));
    },
    fallbackCopyText(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      textarea.style.top = "0";
      document.body.appendChild(textarea);
      textarea.select();
      let copied = false;
      try {
        copied = document.execCommand("copy");
      } catch (error) {
        copied = false;
      }
      document.body.removeChild(textarea);
      return copied;
    },
    toggleApiKey() {
      this.apiKeyVisible = !this.apiKeyVisible;
    },
    normalizePhone(value) {
      return String(value || "")
        .split("@")[0]
        .replace(/\D/g, "");
    },
    isValidPhone(value) {
      return /^[0-9]{10,15}$/.test(this.normalizePhone(value));
    },
    async fetchConnectionStatus(phone, silent) {
      const targetPhone =
        typeof phone === "undefined" ? this.licenseInfo.license_phone_number : phone;
      if (!this.isValidPhone(targetPhone)) {
        this.connectionStatus = null;
        this.connectionStatusMessage = "Nomor WhatsApp belum valid atau belum diatur.";
        this.connectionLoading = false;
        return null;
      }
      if (!silent) {
        this.connectionLoading = true;
      }
      try {
        const response = await this.$store.dispatch("omniwa/isOnline", targetPhone);
        const data = (response && response.data) || {};
        const rawStatus = data.status;
        let status = null;
        if (rawStatus === 1 || rawStatus === "1") {
          status = 1;
        } else if (rawStatus === 0 || rawStatus === "0") {
          status = 0;
        }
        this.connectionStatus = status;
        this.connectionStatusMessage =
          data.message ||
          (status === 1 ? "Online" : status === 0 ? "Offline" : "Status koneksi belum dapat dipastikan.");
        return status;
      } catch (error) {
        this.connectionStatus = null;
        this.connectionStatusMessage = "Status koneksi belum dapat dipastikan.";
        return null;
      } finally {
        if (!silent) {
          this.connectionLoading = false;
        }
      }
    },
    onConnectionStatusChange(data) {
      if (!data) {
        return;
      }
      const status = Number(data.status);
      if (status === 1 || status === 0) {
        this.connectionStatus = status;
        this.connectionStatusMessage = data.message || (status === 1 ? "Online" : "Offline");
      }
    },
    async waitForOffline(phone) {
      for (let attempt = 0; attempt < 10; attempt += 1) {
        await new Promise(done => setTimeout(done, 1000));
        if (!this.editModalOpen) {
          return false;
        }
        const status = await this.fetchConnectionStatus(phone, true);
        if (status === 0) {
          return true;
        }
      }
      return false;
    },
    async disconnectWhatsappForEdit() {
      if (!this.canDisconnectWhatsapp || this.disconnectLoading) {
        return;
      }
      const phone = this.licenseInfo.license_phone_number;
      const confirmation = await this.$fire({
        title: "Putuskan koneksi WhatsApp?",
        text: "Nomor WhatsApp baru dapat diubah setelah status Offline terkonfirmasi.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, putuskan",
        cancelButtonText: "Batal",
        confirmButtonColor: "#dc3545"
      });
      if (!this.isConfirmed(confirmation)) {
        return;
      }
      this.disconnectLoading = true;
      this.connectionError = "";
      this.editErrors.phone = "";
      try {
        const response = await this.$store.dispatch("omniwa/logout", phone);
        if (!this.editModalOpen) {
          return;
        }
        const offline = await this.waitForOffline(phone);
        if (!this.editModalOpen) {
          return;
        }
        if (!offline) {
          this.connectionError =
            "Status Offline belum terkonfirmasi. Nomor WhatsApp tetap terkunci.";
          return;
        }
        this.connectionStatus = 0;
        this.connectionStatusMessage = "Offline";
        this.$fire({
          title: "Berhasil",
          text:
            (response && response.msg) ||
            "Koneksi WhatsApp berhasil diputus. Nomor sekarang dapat diubah.",
          type: "success",
          timer: 3000
        });
        if (this.$refs.whatsapp_section) {
          this.$refs.whatsapp_section.isOnline(phone);
        }
      } catch (error) {
        this.connectionError = this.getErrorMessage(
          error,
          "Koneksi WhatsApp belum dapat diputus. Nomor tetap terkunci."
        );
      } finally {
        this.disconnectLoading = false;
      }
    },
    resetLicenseEdit() {
      this.editSaving = false;
      this.editModalOpen = false;
      this.connectionStatus = null;
      this.connectionStatusMessage = "";
      this.connectionLoading = false;
      this.disconnectLoading = false;
      this.connectionError = "";
      this.editForm = {
        id: "",
        license_name: "",
        license_email: "",
        license_phone_number: ""
      };
      this.editErrors = {
        name: "",
        email: "",
        phone: "",
        api: ""
      };
      this.closeModal("editLicenseDetail");
    },
    async openLicenseEdit() {
      if (!this.licenseInfo.id || this.editSaving) {
        return;
      }
      this.editForm = {
        id: this.licenseInfo.id,
        license_name: this.licenseInfo.license_name || "",
        license_email: this.licenseInfo.license_email || "",
        license_phone_number: this.normalizePhone(this.licenseInfo.license_phone_number)
      };
      this.editErrors = {
        name: "",
        email: "",
        phone: "",
        api: ""
      };
      this.connectionError = "";
      this.connectionStatus = null;
      this.connectionStatusMessage = "";
      this.editModalOpen = true;
      this.showModal("editLicenseDetail");
      await this.fetchConnectionStatus(this.licenseInfo.license_phone_number);
    },
    closeLicenseEdit() {
      if (this.editSaving) {
        return;
      }
      this.resetLicenseEdit();
    },
    validateLicenseEdit() {
      this.editErrors.name = "";
      this.editErrors.email = "";
      this.editErrors.phone = "";
      this.editErrors.api = "";
      const name = String(this.editForm.license_name || "").trim();
      const email = String(this.editForm.license_email || "").trim();
      const phone = this.normalizePhone(this.editForm.license_phone_number);
      let valid = true;

      if (!name) {
        this.editErrors.name = "Nama lisensi wajib diisi.";
        valid = false;
      }
      if (!email) {
        this.editErrors.email = "Email wajib diisi.";
        valid = false;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.editErrors.email = "Format email belum valid.";
        valid = false;
      }
      if (!this.isValidPhone(phone)) {
        this.editErrors.phone = "Nomor WhatsApp harus terdiri dari 10-15 digit angka.";
        valid = false;
      }
      if (!this.licenseInfo.id) {
        this.editErrors.api = "Lisensi tidak ditemukan.";
        valid = false;
      }
      return valid;
    },
    async saveLicenseEdit() {
      if (
        this.editSaving ||
        this.disconnectLoading ||
        this.connectionLoading ||
        !this.validateLicenseEdit()
      ) {
        return;
      }
      const licenseId = this.licenseInfo.id;
      const requestId = this.requestId;
      const name = String(this.editForm.license_name || "").trim();
      const email = String(this.editForm.license_email || "").trim();
      const phone = this.normalizePhone(this.editForm.license_phone_number);
      const originalPhone = this.normalizePhone(this.licenseInfo.license_phone_number);
      const phoneChanged = phone !== originalPhone;
      const phoneToSend = phoneChanged
        ? phone
        : this.licenseInfo.license_phone_number || phone;
      this.editSaving = true;
      this.editErrors.api = "";

      try {
        if (phoneChanged && this.isValidPhone(this.licenseInfo.license_phone_number)) {
          const status = await this.fetchConnectionStatus(
            this.licenseInfo.license_phone_number,
            true
          );
          if (status !== 0) {
            this.editErrors.phone =
              status === 1
                ? "Nomor WhatsApp tidak dapat diubah saat masih terhubung. Putuskan koneksi WhatsApp terlebih dahulu untuk mengganti nomor."
                : "Status koneksi belum dapat dipastikan. Nomor WhatsApp tetap terkunci sampai status Offline terkonfirmasi.";
            return;
          }
        }

        const payload = {
          id: licenseId,
          license_name: name,
          license_email: email,
          license_phone_number: phoneToSend
        };
        const response = await this.$store.dispatch("license/updateStored", payload);
        if (requestId !== this.requestId || licenseId !== this.licenseInfo.id) {
          return;
        }
        this.licenseInfo = Object.assign({}, this.licenseInfo, {
          license_name: name,
          license_email: email,
          license_phone_number: phoneToSend
        });
        if (phoneChanged) {
          this.connectionStatus = null;
          this.connectionStatusMessage = "";
        }
        this.editModalOpen = false;
        this.closeModal("editLicenseDetail");
        this.$fire({
          title: "Berhasil",
          text: (response && response.msg) || "Perubahan berhasil disimpan.",
          type: "success",
          timer: 3000
        });

        try {
          const refreshed = await this.$store.dispatch("license/getLicenseById", licenseId);
          if (
            requestId === this.requestId &&
            licenseId === this.licenseInfo.id &&
            refreshed &&
            refreshed.data
          ) {
            this.licenseInfo = Object.assign({}, this.licenseInfo, refreshed.data);
          }
        } catch (error) {
          // Simpan sudah berhasil; kegagalan refresh tidak boleh menutupi hasil simpan.
        }
      } catch (error) {
        if (requestId === this.requestId && licenseId === this.licenseInfo.id) {
          this.editErrors.api = this.getErrorMessage(
            error,
            "Perubahan belum dapat disimpan. Coba lagi."
          );
        }
      } finally {
        this.editSaving = false;
      }
    },
    showModal(id) {
      const jq = window.jQuery || window.$;
      if (jq && jq.fn && jq.fn.modal) {
        jq("#" + id).modal("show");
        return;
      }
      const element = document.getElementById(id);
      if (element) {
        element.style.display = "block";
        element.classList.add("show");
        document.body.classList.add("modal-open");
      }
    },
    closeModal(id) {
      const jq = window.jQuery || window.$;
      if (jq && jq.fn && jq.fn.modal) {
        jq("#" + id).modal("hide");
        return;
      }
      const element = document.getElementById(id);
      if (element) {
        element.classList.remove("show");
        element.style.display = "none";
        document.body.classList.remove("modal-open");
      }
    },
    generateLicenseKey() {
      if (!this.licenseInfo.id || this.keySubmitting) {
        return;
      }
      this.$fire({
        title: "Generate ulang API key?",
        text: "Tindakan ini akan memutus koneksi API yang menggunakan key lama. Lanjutkan?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, generate",
        cancelButtonText: "Batal",
        confirmButtonColor: "#e8842c"
      })
        .then(async result => {
          if (!this.isConfirmed(result)) {
            return;
          }
          const licenseId = this.licenseInfo.id;
          const requestId = this.requestId;
          this.keySubmitting = true;
          this.apiKeyError = "";
          try {
            const response = await this.$store.dispatch("license/generateLicenseKey", {
              id: licenseId
            });
            if (requestId !== this.requestId || licenseId !== this.licenseInfo.id) {
              return;
            }
            this.apiKeyVisible = false;
            this.$fire({
              title: "Berhasil",
              text: (response && response.msg) || "API key berhasil dibuat ulang.",
              type: "success",
              timer: 3000
            });
            const refreshed = await this.$store.dispatch("license/getLicenseById", licenseId);
            if (
              requestId === this.requestId &&
              licenseId === this.licenseInfo.id &&
              refreshed &&
              refreshed.data
            ) {
              this.licenseInfo = Object.assign({}, this.licenseInfo, refreshed.data);
            }
          } catch (error) {
            this.apiKeyError = this.getErrorMessage(
              error,
              "API key belum dapat dibuat ulang. Coba lagi."
            );
          } finally {
            this.keySubmitting = false;
          }
        })
        .catch(() => {});
    },
    isConfirmed(result) {
      return Boolean(result && (result.isConfirmed || result.value === true));
    },
    confirmEmpty(type) {
      if (!this.licenseInfo.id || this.emptyLoading) {
        return;
      }
      const isInbox = type === "inbox";
      this.$fire({
        title: isInbox ? "Kosongkan pesan masuk?" : "Kosongkan pesan keluar?",
        text: isInbox
          ? "Semua pesan masuk pada lisensi ini akan dihapus permanen. Tindakan ini tidak dapat dibatalkan."
          : "Semua pesan keluar pada lisensi ini akan dihapus permanen. Tindakan ini tidak dapat dibatalkan.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, hapus permanen",
        cancelButtonText: "Batal",
        confirmButtonColor: "#dc3545"
      })
        .then(async result => {
          if (!this.isConfirmed(result)) {
            return;
          }
          const licenseId = this.licenseInfo.id;
          this.emptyLoading = type;
          this.emptyError = "";
          try {
            const response = await this.$store.dispatch(
              isInbox ? "license/emptyInbox" : "license/emptyOutbox",
              { license_id: licenseId }
            );
            if (licenseId !== this.licenseInfo.id) {
              return;
            }
            this.$fire({
              title: "Berhasil",
              text: (response && response.msg) || (isInbox ? "Pesan masuk berhasil dihapus." : "Pesan keluar berhasil dihapus."),
              type: "success",
              timer: 3000
            });
            this.loadMetrics(licenseId);
          } catch (error) {
            if (licenseId !== this.licenseInfo.id) {
              return;
            }
            this.emptyError = this.getErrorMessage(
              error,
              isInbox
                ? "Pesan masuk belum dapat dihapus. Coba lagi."
                : "Pesan keluar belum dapat dihapus. Coba lagi."
            );
          } finally {
            this.emptyLoading = "";
          }
        })
        .catch(() => {});
    }
  },
  name: "license-detail"
};
</script>

<style>
.license-detail-page {
  padding-bottom: 40px;
}

.license-detail-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.license-detail-heading-copy h3 {
  margin-bottom: 6px;
  color: #1f2937;
  font-weight: 700;
}

.license-detail-heading-copy p {
  margin-bottom: 8px;
  color: #6b7280;
}

.license-detail-heading-copy .breadcrumb {
  margin-bottom: 0;
  background: transparent;
  padding: 0;
}

.license-detail-heading-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.license-detail-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-radius: 9px;
  font-weight: 600;
  font-size: 13px;
  padding: 8px 14px;
  border: 1px solid transparent;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.license-detail-btn:disabled {
  opacity: 0.62;
  cursor: not-allowed;
}

.license-detail-btn-primary {
  background: #f3922d;
  border-color: #f3922d;
  color: #ffffff;
}

.license-detail-btn-primary:hover,
.license-detail-btn-primary:focus {
  background: #e8842c;
  border-color: #e8842c;
  color: #ffffff;
}

.license-detail-btn-secondary {
  background: #ffffff;
  border-color: #dfe3e8;
  color: #374151;
}

.license-detail-btn-secondary:hover,
.license-detail-btn-secondary:focus {
  background: #f8fafc;
  border-color: #cfd5dd;
  color: #111827;
}

.license-detail-btn-danger {
  background: #fff5f5;
  border-color: #f5b5b5;
  color: #c82333;
}

.license-detail-btn-danger:hover,
.license-detail-btn-danger:focus {
  background: #ffe9e9;
  border-color: #ef9a9a;
  color: #a71d2a;
}

.license-detail-panel {
  background: #ffffff;
  border: 1px solid #e8ebef;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
  padding: 18px;
  margin-bottom: 18px;
}

.license-detail-loading {
  padding: 22px;
}

.license-detail-skeleton {
  background: #eef2f6;
  border-radius: 10px;
  animation: license-detail-pulse 1.2s ease-in-out infinite;
}

.license-detail-skeleton-hero {
  height: 132px;
  margin-bottom: 16px;
}

.license-detail-skeleton-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.license-detail-skeleton-card {
  height: 92px;
}

.license-detail-skeleton-line {
  height: 16px;
  margin-bottom: 10px;
}

.license-detail-skeleton-line.is-short {
  width: 55%;
}

@keyframes license-detail-pulse {
  0% { opacity: 0.65; }
  50% { opacity: 1; }
  100% { opacity: 0.65; }
}

.license-detail-state {
  text-align: center;
  padding: 42px 20px;
}

.license-detail-state-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: #eef6ff;
  color: #2b7de9;
  font-size: 22px;
  margin-bottom: 12px;
}

.license-detail-state-icon.is-danger {
  background: #fff1f1;
  color: #d64545;
}

.license-detail-state h4 {
  color: #1f2937;
  font-weight: 700;
}

.license-detail-state p {
  color: #6b7280;
  max-width: 540px;
  margin: 0 auto 16px;
}

.license-detail-state-actions {
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.license-detail-hero {
  display: flex;
  gap: 22px;
  align-items: stretch;
  justify-content: space-between;
  background: #ffffff;
  border: 1px solid #e8ebef;
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
  padding: 22px;
  margin-bottom: 18px;
}

.license-detail-hero-main {
  display: flex;
  gap: 16px;
  min-width: 0;
  flex: 1 1 auto;
}

.license-detail-hero-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: #e8f8ef;
  color: #25a55b;
  font-size: 32px;
}

.license-detail-hero-copy {
  min-width: 0;
}

.license-detail-hero-title {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.license-detail-hero-title h1 {
  margin: 0;
  font-size: 24px;
  line-height: 1.25;
  font-weight: 700;
  color: #1f2937;
  word-break: break-word;
}

.license-detail-edit-title {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-height: 27px;
  padding: 2px 9px;
  border-radius: 7px;
  color: #6b7280;
  background: #f8fafc;
  border: 1px solid #e5e9ef;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
}

.license-detail-edit-title:hover,
.license-detail-edit-title:focus {
  color: #e8842c;
  border-color: #f0c08e;
  text-decoration: none;
  outline: none;
}

.license-detail-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.license-detail-badge i {
  font-size: 7px;
}

.license-detail-badge.is-active {
  background: #e8f8ef;
  color: #1f8a4c;
}

.license-detail-badge.is-expired {
  background: #fff1f1;
  color: #c82333;
}

.license-detail-badge.is-neutral {
  background: #f1f3f5;
  color: #6c757d;
}

.license-detail-hero-meta {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 10px;
  color: #6b7280;
  font-size: 13px;
}

.license-detail-phone-copy {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px dashed #d5dbe2;
  background: #f8fafc;
  color: #374151;
  border-radius: 8px;
  padding: 5px 10px;
  font-size: 13px;
  font-weight: 600;
}

.license-detail-phone-copy:hover,
.license-detail-phone-copy:focus {
  background: #f1f5f9;
  border-color: #bcc6d1;
  outline: none;
}

.license-detail-phone-copy .fa-files-o {
  color: #94a3b8;
  font-size: 12px;
}

.license-detail-meta-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  word-break: break-word;
}

.license-detail-hero-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 16px;
}

.license-detail-more {
  display: inline-block;
}

.license-detail-more .dropdown-menu {
  min-width: 230px;
  border-radius: 10px;
  border-color: #e5e7eb;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
}

.license-detail-more .dropdown-item {
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 13px;
  padding: 8px 14px;
}

.license-detail-hero-side {
  flex: 0 0 290px;
  border-left: 1px solid #eef1f4;
  padding-left: 22px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.license-detail-side-item > span {
  display: block;
  color: #8a94a3;
  font-size: 12px;
  margin-bottom: 3px;
}

.license-detail-side-item > strong {
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
}

.license-detail-pill {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 3px 9px;
  font-size: 12px;
  font-weight: 600;
}

.license-detail-pill.is-blue {
  background: #eaf3ff;
  color: #2b7de9;
}

.license-detail-status-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.license-detail-status-list > li {
  margin: 0;
  padding: 0;
}

.license-detail-status-list .title {
  display: none;
}

.license-detail-status-list .text > h5 {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
}

.license-detail-status-list .team-members {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.license-detail-status-list .team-members li {
  margin: 0;
}

.license-detail-status-list .btn-light {
  padding: 4px 8px;
  border-radius: 7px;
  line-height: 1;
}

.license-detail-status-list .btn-primary {
  padding: 5px 10px;
  border-radius: 8px;
  font-size: 12px;
  background: #f3922d;
  border-color: #f3922d;
}

.license-detail-status-list.is-panel {
  margin-bottom: 14px;
}

.license-detail-status-list.is-panel .title {
  display: inline;
  font-weight: 600;
  color: #374151;
  margin-right: 8px;
}

.license-detail-status-list.is-panel .text > h5 {
  display: inline-flex;
  margin: 0 0 8px;
}

.license-detail-stats {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.license-detail-stat-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #ffffff;
  border: 1px solid #e8ebef;
  border-radius: 14px;
  padding: 15px;
  min-height: 96px;
}

.license-detail-stat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  font-size: 17px;
}

.license-detail-stat-icon.is-blue,
.license-detail-stat-card.is-blue .license-detail-stat-icon {
  background: #eaf3ff;
  color: #2b7de9;
}

.license-detail-stat-icon.is-green,
.license-detail-stat-card.is-green .license-detail-stat-icon {
  background: #e8f8ef;
  color: #25a55b;
}

.license-detail-stat-icon.is-amber,
.license-detail-stat-card.is-amber .license-detail-stat-icon {
  background: #fff5e6;
  color: #d98314;
}

.license-detail-stat-icon.is-red,
.license-detail-stat-card.is-red .license-detail-stat-icon {
  background: #fff0f0;
  color: #d64545;
}

.license-detail-stat-icon.is-purple,
.license-detail-stat-card.is-purple .license-detail-stat-icon {
  background: #f2edff;
  color: #7c5cd6;
}

.license-detail-stat-copy {
  min-width: 0;
}

.license-detail-stat-copy > span {
  display: block;
  color: #6b7280;
  font-size: 12px;
}

.license-detail-stat-rate {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 1px 6px;
  margin-left: 4px;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.5;
  vertical-align: middle;
}

.license-detail-stat-rate.is-green {
  background: #e8f8ef;
  color: #1f8a4c;
}

.license-detail-stat-rate.is-red {
  background: #fff0f0;
  color: #c82333;
}

.license-detail-stat-copy > strong {
  display: block;
  color: #1f2937;
  font-size: 22px;
  line-height: 1.3;
  font-weight: 700;
  word-break: break-word;
}

.license-detail-stat-copy > small {
  display: block;
  color: #9aa3af;
  font-size: 11px;
  line-height: 1.3;
}

.license-detail-stats-note {
  margin: -6px 0 14px;
}

.license-detail-inline-alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  background: #fff8e6;
  border: 1px solid #f3d28d;
  color: #8a5a00;
  border-radius: 10px;
  padding: 10px 14px;
  margin-bottom: 16px;
  font-size: 13px;
}

.license-detail-inline-alert.is-danger {
  background: #fff5f5;
  border-color: #f5b5b5;
  color: #a71d2a;
}

.license-detail-link-btn {
  border: 0;
  background: transparent;
  color: inherit;
  font-weight: 700;
  text-decoration: underline;
  padding: 0;
}

.license-detail-tabs-head {
  border-bottom: 1px solid #e8ebef;
  margin-bottom: 18px;
}

.license-detail-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  overflow-x: auto;
  scrollbar-width: thin;
}

.license-detail-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 0;
  background: transparent;
  color: #6b7280;
  font-weight: 600;
  font-size: 13px;
  padding: 11px 16px;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
}

.license-detail-tab:hover,
.license-detail-tab:focus {
  color: #1f2937;
  outline: none;
}

.license-detail-tab.active {
  color: #e8842c;
  border-bottom-color: #f3922d;
}

.license-detail-tab-panel {
  margin-bottom: 8px;
}

.license-detail-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(280px, 1fr);
  gap: 18px;
  align-items: start;
}

.license-detail-grid.is-single {
  grid-template-columns: minmax(0, 1fr);
}

.license-detail-main-column,
.license-detail-side-column {
  min-width: 0;
}

.license-detail-panel-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.license-detail-panel-head h4,
.license-detail-help h4,
.license-detail-doc-card h4 {
  margin: 0 0 3px;
  color: #1f2937;
  font-size: 16px;
  font-weight: 700;
}

.license-detail-panel-head p,
.license-detail-help p,
.license-detail-doc-card p {
  margin: 0;
  color: #6b7280;
  font-size: 13px;
}

.license-detail-info-list {
  margin: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px 22px;
}

.license-detail-info-list > div {
  min-width: 0;
}

.license-detail-info-list dt {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #8a94a3;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 3px;
}

.license-detail-info-list dd {
  margin: 0;
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
  word-break: break-word;
}

.license-detail-info-box {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #f8fbff;
  border-color: #e1ecfa;
}

.license-detail-info-box-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: #eaf3ff;
  color: #2b7de9;
}

.license-detail-info-box strong {
  display: block;
  color: #1f2937;
  margin-bottom: 3px;
}

.license-detail-info-box p {
  margin: 0;
  color: #6b7280;
  font-size: 13px;
}

.license-detail-quick-card,
.license-detail-activity-card {
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  text-align: left;
  background: #ffffff;
  border: 1px solid #e8ebef;
  border-radius: 11px;
  padding: 11px 12px;
  color: #1f2937;
  margin-bottom: 9px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.license-detail-quick-card:hover,
.license-detail-quick-card:focus,
.license-detail-activity-card:hover,
.license-detail-activity-card:focus {
  text-decoration: none;
  border-color: #f0c08e;
  box-shadow: 0 4px 12px rgba(243, 146, 45, 0.12);
  outline: none;
}

.license-detail-quick-card:last-child {
  margin-bottom: 0;
}

.license-detail-quick-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  font-size: 16px;
}

.license-detail-quick-icon.is-key {
  background: #fff5e6;
  color: #d98314;
}

.license-detail-quick-icon.is-doc {
  background: #eaf3ff;
  color: #2b7de9;
}

.license-detail-quick-icon.is-qr {
  background: #e8f8ef;
  color: #25a55b;
}

.license-detail-quick-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 auto;
}

.license-detail-quick-copy strong {
  font-size: 13px;
  font-weight: 700;
  color: #1f2937;
}

.license-detail-quick-copy small {
  font-size: 12px;
  color: #8a94a3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.license-detail-quick-card > .fa-angle-right,
.license-detail-quick-card > .fa-external-link,
.license-detail-activity-card > .fa-angle-right {
  color: #b0b8c3;
  font-size: 13px;
}

.license-detail-help {
  background: #fffbef;
  border-color: #f4e3b6;
}

.license-detail-help-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #f7b955;
  color: #ffffff;
  margin-bottom: 9px;
}

.license-detail-help .btn {
  margin-top: 12px;
}

.license-detail-key-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  background: #f8fafc;
  border: 1px solid #e5e9ef;
  border-radius: 11px;
  padding: 10px;
}

.license-detail-key {
  flex: 1 1 260px;
  min-width: 0;
  background: transparent;
  color: #374151;
  font-size: 13px;
  word-break: break-all;
  white-space: normal;
  margin: 0;
}

.license-detail-key-actions {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
}

.license-detail-doc-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.license-detail-doc-card .btn {
  margin-top: 10px;
}

.license-detail-muted {
  color: #8a94a3;
  font-size: 12px;
  margin: 10px 0 0;
}

.license-detail-activity-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.license-detail-activity-card {
  margin-bottom: 0;
}

.license-detail-activity-card > div {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
}

.license-detail-activity-card strong {
  font-size: 13px;
  font-weight: 700;
}

.license-detail-activity-card small {
  color: #8a94a3;
  font-size: 12px;
}

.license-detail-settings-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 6px;
}

.license-detail-danger {
  background: #fff7f7;
  border: 1px solid #f3cccc;
  border-radius: 14px;
  padding: 18px;
  margin-top: 8px;
}

.license-detail-danger-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
}

.license-detail-danger-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #f06a6a;
  color: #ffffff;
  font-weight: 700;
}

.license-detail-danger-head h4 {
  margin: 0 0 3px;
  color: #a71d2a;
  font-size: 16px;
  font-weight: 700;
}

.license-detail-danger-head p {
  margin: 0;
  color: #8b3a42;
  font-size: 13px;
  max-width: 900px;
}

.license-detail-danger-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.license-detail-danger-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  background: #ffffff;
  border: 1px solid #f3cccc;
  border-radius: 11px;
  padding: 12px 14px;
}

.license-detail-danger-card strong {
  display: block;
  color: #1f2937;
  font-size: 13px;
  font-weight: 700;
}

.license-detail-danger-card p {
  margin: 0;
  color: #8a5a5f;
  font-size: 12px;
}

.license-detail-modal .modal-content {
  border: 1px solid #e8ebef;
  border-radius: 14px;
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.16);
}

.license-detail-modal .modal-header {
  border-bottom: 1px solid #eef1f4;
  padding: 16px 20px;
}

.license-detail-modal .modal-title {
  color: #1f2937;
  font-size: 17px;
  font-weight: 700;
}

.license-detail-modal .modal-title i {
  color: #e8842c;
  margin-right: 6px;
}

.license-detail-modal .modal-body {
  padding: 18px 20px 20px;
}

.license-detail-form-note {
  color: #6b7280;
  font-size: 13px;
  margin-bottom: 16px;
}

.license-detail-modal .form-group {
  margin-bottom: 15px;
}

.license-detail-edit-status {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.license-detail-btn-sm {
  height: 30px;
  padding: 0 10px;
  font-size: 12px;
}

.license-detail-modal .form-group label {
  color: #374151;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}

.license-detail-modal .form-control {
  border-color: #dfe3e8;
  border-radius: 9px;
  font-size: 13px;
  min-height: 38px;
}

.license-detail-modal .form-control:focus {
  border-color: #f0b36a;
  box-shadow: 0 0 0 3px rgba(243, 146, 45, 0.12);
}

.license-detail-modal .form-control.is-invalid {
  border-color: #e07a7a;
}

.license-detail-modal .invalid-feedback {
  display: block;
  color: #c82333;
  font-size: 12px;
}

.license-detail-modal .license-detail-readonly {
  background: #f8fafc;
  color: #6b7280;
  cursor: not-allowed;
}

.license-detail-modal .form-text {
  font-size: 12px;
}

.license-detail-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  border-top: 1px solid #eef1f4;
  margin-top: 18px;
  padding-top: 15px;
}

@media (max-width: 1199px) {
  .license-detail-stats,
  .license-detail-skeleton-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .license-detail-hero-side {
    flex-basis: 250px;
  }
}

@media (max-width: 991px) {
  .license-detail-hero {
    flex-direction: column;
  }

  .license-detail-hero-side {
    flex: 1 1 auto;
    border-left: 0;
    border-top: 1px solid #eef1f4;
    padding-left: 0;
    padding-top: 16px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
  }

  .license-detail-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .license-detail-side-column {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;
  }

  .license-detail-side-column .license-detail-panel {
    margin-bottom: 0;
  }
}

@media (max-width: 767px) {
  .license-detail-page {
    padding-left: 12px;
    padding-right: 12px;
  }

  .license-detail-heading-actions {
    width: 100%;
  }

  .license-detail-heading-actions .license-detail-btn {
    flex: 1 1 auto;
  }

  .license-detail-hero {
    padding: 16px;
  }

  .license-detail-hero-main {
    flex-direction: column;
  }

  .license-detail-hero-icon {
    width: 52px;
    height: 52px;
    font-size: 26px;
  }

  .license-detail-hero-title h1 {
    font-size: 20px;
  }

  .license-detail-hero-actions .license-detail-btn,
  .license-detail-hero-actions .license-detail-more {
    flex: 1 1 auto;
  }

  .license-detail-hero-actions .license-detail-more .license-detail-btn {
    width: 100%;
  }

  .license-detail-hero-side {
    grid-template-columns: minmax(0, 1fr);
  }

  .license-detail-stats,
  .license-detail-skeleton-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .license-detail-side-column {
    grid-template-columns: minmax(0, 1fr);
  }

  .license-detail-info-list {
    grid-template-columns: minmax(0, 1fr);
  }

  .license-detail-activity-grid,
  .license-detail-danger-actions {
    grid-template-columns: minmax(0, 1fr);
  }

  .license-detail-key-actions {
    width: 100%;
  }

  .license-detail-key-actions .license-detail-btn {
    flex: 1 1 auto;
  }

  .license-detail-danger-card {
    flex-direction: column;
    align-items: stretch;
  }

  .license-detail-danger-card .license-detail-btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .license-detail-stats,
  .license-detail-skeleton-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .license-detail-tab {
    padding: 10px 12px;
    font-size: 12px;
  }

  .license-detail-modal-actions {
    flex-direction: column-reverse;
  }

  .license-detail-modal-actions .btn {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/license/info.vue